import ReportSummaryService from "@/services/reportsummary.service";

const state = {
    reportList: [],
    reportBuildList: [],
    historySummary: [],
    transferHistory: [],
    historyError: []
};

const mutations = {

    set_report(state, payload) {
        state.reportList = payload;
    },
    clear_report(state) {
        state.reportList = [];
    },

    set_reportBuild(state, payload) {
        state.reportBuildList = payload
    },
    clear_reportBuild(state) {
        state.reportBuildList = [];
    },

    set_historyBuilderSummary(state, payload) {
        state.historySummary = payload
    },
    clear_historyBuilderSummary(state) {
        state.historySummary = [];
    },

    set_transferHistory(state, payload) {
        state.transferHistory = payload
    },

    clear_transferHistory(state) {
        state.transferHistory = [];
    },

    set_historyError(state, payload) {
        state.historyError = payload
    },
    clear_historyError(state) {
        state.historyError = [];
    }
};

const actions = {

    async getReportList({commit}, payload) {
        commit("clear_report");
        const report = await ReportSummaryService.getReportSummary_Service(payload);
        commit("set_report", report);
        return report.data;
    },

    async getReportBuildList({commit}) {
        commit("clear_reportBuild");
        const reportBuildList = await ReportSummaryService.getReportBuildList_Service();
        commit("set_reportBuild", reportBuildList);
        return reportBuildList.data;
    },

    async getHistoryBuilderAndTransferSummary({commit}, payload) {
        commit("clear_historyBuilderSummary");
        commit("clear_transferHistory");
        const historySummary = await ReportSummaryService.getHistoryBuilderAndTransferSummary_Service(payload);
        //alert("historySummary")
        commit("set_historyBuilderSummary", JSON.parse(historySummary.data.builderSummary));
        commit("set_transferHistory", JSON.parse(historySummary.data.transferSummary));
        return historySummary.data;
    },

    // async getHistoryBuilderSummary({commit}) {
    //     commit("clear_historyBuilderSummary");
    //     const historySummary = await ReportSummaryService.getHistoryBuilderSummary_Service();
    //     commit("set_historyBuilderSummary", historySummary);
    //     return historySummary.data;
    // },
    //
    // async getTransferHistory({commit}) {
    //     commit("clear_transferHistory");
    //     const transferHistory = await ReportSummaryService.getTransferHistory_Service();
    //     commit("set_transferHistory", transferHistory);
    //     return transferHistory.data;
    // },

    async regenerateReportsBySelectedDay(selectedDay)
    {

        const respmessage = await ReportSummaryService.regenerateReportsBySelectedDay(selectedDay);

        return respmessage;

    },

    async reportBuilderHistoryError({commit}, payload) {
        commit("clear_historyError");
        const historyError = await ReportSummaryService.reportBuilderHistoryError_Service(payload);
        commit("set_historyError", historyError);
        return historyError.data;
    }

};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
